import { type Column, type Row } from "@tanstack/react-table";
import { useMemo } from "react";

import { type DataGridColumnDef } from "../useColumnState";
import { type ColumnType, parseColumnType } from "../validation/parseColumnType";

export interface InferredColumns {
	[columnId: string]: ColumnType;
}

export function useInferredColumnTypes<T>(
	row: Row<T> | undefined,
	columns: Column<T, unknown>[]
): InferredColumns {
	const inferredColumnTypes = useMemo(() => {
		const columnTypes = (row?.getAllCells() || []).reduce((types, cell) => {
			const fieldType = (cell.column.columnDef as DataGridColumnDef<unknown, unknown>)
				?.fieldType;

			if (fieldType === "Auto" || !fieldType) {
				const parsed = parseColumnType(cell.getValue());
				return { ...types, [cell.column.id]: parsed };
			}
			return { ...types, [cell.column.id]: fieldType };
		}, {});

		return columnTypes;
	}, [row, columns]);

	return inferredColumnTypes;
}
